'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { DEFAULT_VIVERSE_ORIGIN } from '@/constants/domain';
import { cn } from '@/lib/utils';
import partnerAlphaputtLogo from '@/public/images/viverse-plus/partner-alphaputt-logo.png';
import partnerAlphaputt from '@/public/images/viverse-plus/partner-alphaputt.png';
import partnerBackToBedLogo from '@/public/images/viverse-plus/partner-back-to-bed-logo.png';
import partnerBackToBed from '@/public/images/viverse-plus/partner-back-to-bed.png';
import partnerOvivoLogo from '@/public/images/viverse-plus/partner-ovivo-logo.png';
import partnerOvivo from '@/public/images/viverse-plus/partner-ovivo.png';
import partnerShipHappensLogo from '@/public/images/viverse-plus/partner-ship-happens-logo.png';
import partnerShipHappens from '@/public/images/viverse-plus/partner-ship-happens.png';
import partnerVoodooDetectiveLogo from '@/public/images/viverse-plus/partner-voodoo-detective-logo.png';
import partnerVoodooDetective from '@/public/images/viverse-plus/partner-voodoo-detective.png';
const partners = [{
  key: 'alphaputt',
  title: 'Alphaputt',
  creator: 'Sennep',
  href: `${DEFAULT_VIVERSE_ORIGIN}/NT8vChy`,
  image: partnerAlphaputt,
  logo: partnerAlphaputtLogo,
  accentClassName: 'bg-[#e8c84a]',
  logoPositionClassName: 'bottom-[-6px] left-[-25px]',
  logoClassName: 'h-[70px] w-[87px] object-cover object-[50%_15%]'
}, {
  key: 'back-to-bed',
  title: 'Back To Bed',
  creator: 'Bedtime Digital Games',
  href: `${DEFAULT_VIVERSE_ORIGIN}/uzMBdJh`,
  image: partnerBackToBed,
  logo: partnerBackToBedLogo,
  accentClassName: 'bg-[#e87a4a]',
  logoPositionClassName: 'bottom-[-5px] left-[-23px]',
  logoClassName: 'h-[55px] w-[55px] object-contain'
}, {
  key: 'voodoo-detective',
  title: 'Voodoo Detective',
  creator: 'Short Sleeve Studio',
  href: `${DEFAULT_VIVERSE_ORIGIN}/agzXjak`,
  image: partnerVoodooDetective,
  logo: partnerVoodooDetectiveLogo,
  accentClassName: 'bg-[#4a7ae8]',
  logoPositionClassName: 'bottom-[-4px] left-[-23px]',
  logoClassName: 'h-[42px] w-[55px] object-cover object-top'
}, {
  key: 'ovivo',
  title: 'Ovivo',
  creator: 'Alexandr Vilassak',
  href: `${DEFAULT_VIVERSE_ORIGIN}/iv9gsHj`,
  image: partnerOvivo,
  logo: partnerOvivoLogo,
  accentClassName: 'bg-[#b6c3d6]',
  logoPositionClassName: 'bottom-0 left-[-15px]',
  logoClassName: 'h-[47px] w-[47px] rounded-full object-cover'
}, {
  key: 'ship-happens',
  title: 'Ship Happens',
  creator: 'Cause+Christi',
  href: `${DEFAULT_VIVERSE_ORIGIN}/2QmJmR2`,
  image: partnerShipHappens,
  logo: partnerShipHappensLogo,
  accentClassName: 'bg-[#00c8aa]',
  logoPositionClassName: 'bottom-[-2px] left-[-15px]',
  logoClassName: 'h-[47px] w-[47px] rounded-full bg-[#2c3643] object-contain p-2'
}] as const;
export default function AwardWinningPartnersSection() {
  const $ = _c(32);
  const t = useTranslations();
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      y: 16
    };
    t1 = {
      opacity: 1,
      y: 0
    };
    t2 = {
      once: true,
      amount: 0.2
    };
    t3 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("plus.award-winning-partners.eyebrow");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <p className="text-vive-primary-40 text-xs leading-4 font-extrabold tracking-[6.15px] uppercase">{t4}</p>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("plus.award-winning-partners.title");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("plus.award-winning-partners.title-line-two");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <span className="mt-2 block">{t7}</span>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <h2 className="mt-5 text-center text-3xl leading-10 font-extrabold tracking-[0.15px] text-[#eeeef0] sm:text-[38px]">{t6}{t8}</h2>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("plus.award-winning-partners.description");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <p className="text-vive-primary-30 mt-4 text-center text-[15px] leading-[26px]">{t10}</p>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t5 || $[23] !== t9) {
    t12 = <motion.div className="flex flex-col items-center" initial={t0} whileInView={t1} viewport={t2} transition={t3}>{t5}{t9}{t11}</motion.div>;
    $[21] = t11;
    $[22] = t5;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = partners.map((partner, index) => <motion.a key={partner.key} href={partner.href} target="_blank" rel="noreferrer" className="group focus-visible:outline-vive-border-focus w-[163px] shrink-0 snap-start rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4" initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.6,
      ease: "easeOut",
      delay: (index + 1) * 0.12
    }}><div className="relative h-[91px]"><div className="absolute inset-0 overflow-hidden"><Image src={partner.image} alt="" fill={true} sizes="163px" className="object-cover transition-all duration-300 lg:group-hover:scale-110 lg:group-hover:brightness-110" /></div>{partner.logo && <Image src={partner.logo} alt="" width={87} height={70} sizes="87px" className={cn("absolute", partner.logoPositionClassName, partner.logoClassName)} />}</div><p className="text-vive-primary-40 mt-3 text-[11px] leading-[17px] whitespace-nowrap">{t(`plus.award-winning-partners.partners.${partner.key}.award`)}</p><div className={cn("mt-3 h-[3px] w-8 rounded-full", partner.accentClassName)} /><h3 className="mt-3 text-[13px] leading-[19.5px] font-semibold text-[#eeeef0]">{partner.title}</h3><p className="text-vive-primary-40 mt-0.5 text-xs leading-[18px]">{partner.creator}</p></motion.a>);
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = <div className="mt-14 flex w-full snap-x gap-8 overflow-x-auto pb-2 [scrollbar-width:none] sm:gap-10 lg:grid lg:grid-cols-5 lg:gap-x-[50px] lg:overflow-visible [&::-webkit-scrollbar]:hidden">{t13}</div>;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t14) {
    t15 = <div className="overflow-hidden px-6 py-20 sm:px-12 sm:py-18"><div className="mx-auto flex max-w-[1128px] flex-col items-center px-8">{t12}{t14}</div></div>;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}